import { render, staticRenderFns } from "./CollationSheet.vue?vue&type=template&id=0df979f8&scoped=true"
import script from "./CollationSheet.vue?vue&type=script&lang=js"
export * from "./CollationSheet.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/component/panel-simple.css?vue&type=style&index=0&id=0df979f8&prod&scoped=true&lang=css&external"
import style1 from "./CollationSheet.vue?vue&type=style&index=1&id=0df979f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df979f8",
  null
  
)

export default component.exports